import { ACTIONTYPE } from "./reducer";
import {
  multiple_init_select,
  multiple_clear,
} from "~/modules/geosearch/actions";

import * as api from "../apis/posttruck";

export const changShowCardAction = (showType) => (dispatch) => {
  return dispatch({
    type: ACTIONTYPE.CHANGE_SHOWCARD,
    payload: showType,
  });
};

export const setRateAction = (rate) => (dispatch) =>
  dispatch({
    type: ACTIONTYPE.SETRATE,
    payload: rate,
  });

export const addPostTruckAction = (addData) => (dispatch) => {
  dispatch({
    type: ACTIONTYPE.ADD_POSTTRUCK,
    payload: addData,
  });
};
export const removePostTruckAction = (addData) => (dispatch) => {
  dispatch({
    type: ACTIONTYPE.DELETE_POSTTRUCK,
    payload: addData,
  });
};

export const editPostTruckAction = (addData) => (dispatch) => {
  dispatch({
    type: ACTIONTYPE.EDIT_POSTTRUCK,
    payload: addData,
  });
};

export const selectedPostTruckAction = (selectedData) => (dispatch) => {
  dispatch({
    type: ACTIONTYPE.SELECTEDPOSTTRUCK,
    payload: selectedData,
  });
};

export const clearFormAction = () => (dispatch) => {
  dispatch(multiple_clear());
};

// I fule with this
export const ininFormAction = (address) => (dispatch) => {
  const orgPlaceValue =
    address && address.pickup
      ? {
          ...address.pickup,
          name: address.pickup.address,
        }
      : {};
  const desPlaceValue =
    address && address.dropoff
      ? {
          ...address.dropoff,
          name: address.dropoff.address,
        }
      : {};
  dispatch(multiple_init_select("origin", { placeValue: orgPlaceValue }));
  dispatch(multiple_init_select("destination", { placeValue: desPlaceValue }));
};

export const getPostTruckListAction = (getData) => (dispatch, getState) =>
  api.getPostTruckListAPI(getState, getData);

export const createPostTuckAction = (createData) => (dispatch, getState) =>
  api.createPostTruckAPI(getState, createData);

export const deletePostTruckAction = (deleteId) => (dispatch, getState) =>
  api.deletePostTruckAPI(getState, deleteId);

export const deletePostTrucksAction = (deleteIds) => (dispatch, getState) =>
  api.deletePostTrucksAPI(getState, deleteIds);

export const updatePostTruckAction = (updateData) => (dispatch, getState) =>
  api.updatePostTruckAPI(getState, updateData);

export const getDistanceAction = (getData) => (dispatch, getSate) =>
  api.getDistanceAPI(getSate, getData);

export const getRateAction = (getData) => (dispatch, getState) =>
  api.getRate(getState, getData);



// WEBPACK FOOTER //
// ./src/pages/PostTruck/state/action.js